<template>
  <div v-if="activityShow" class="activity">
    <div class="banner">
      <img class="banner-img" :src="activityContribute.poster" alt="" />
      <div class="banner-content">
        <h2>{{ activityContribute.name }}</h2>
        <div class="act-infos">
          <div v-if="activityContribute.type == 1" class="status ing">进行中</div>
          <div v-if="activityContribute.type == 2" class="status end">已结束</div>
        </div>
      </div>
    </div>
    <div class="act-attention">
      <div class="act-intro">
        <sign-title title="活动介绍" :simplicity="true" />
        <div class="intro-txt" v-html="activityContribute.intro"></div>
      </div>
    </div>
    <van-popup v-model="activityContribute.unitShow" closeable close-icon="arrow-down" close-icon-position="top-right" position="bottom"
      :style="{ height: '50%' }">
      <div class="unit-lst-wrap">
        <div class="unit-lst" v-html="activityContribute.unitList"></div>
      </div>
    </van-popup>
    <div class="contribute" @click="toApplyPage" v-if="activityContribute.role === 0">
      <van-button size="large" color="linear-gradient(to right, #5DD682, #5AFF8E)">
        我要投稿
      </van-button>
    </div>
  </div>
  <div v-else class="act-apl">
    <div class="form-ipt">
      <div class="input">
        <van-field readonly clickable name="playerVal" input-align="right" required :disabled="playerColumns.length === 0"
          :value="player" label="参赛选手" :error="playerColumns.length === 0"
          :placeholder="playerColumns.length ? '选择选手' : '请先在个人中心添加学生'" @click="playerShow = true"
          error-message-align="right"  :style="{ marginBottom: '20px' }" />
        <van-popup v-model="playerShow" position="bottom">
          <van-picker show-toolbar :columns="playerColumns" @confirm="playerConfirm" @cancel="playerShow = false" />
        </van-popup>

        <van-field readonly clickable name="playerVal" input-align="right" required 
          :value="areaName" label="所在地" placeholder="请选择省市区" @click="showArea = true"
          error-message-align="right"  />
        <van-popup v-model="showArea" position="bottom">
          <van-area :area-list="areaList" @confirm="onConfirm" @cancel="showArea =false" />
        </van-popup>

        <van-field required input-align="right" clickable name="school" v-model="formData.school"
          label="就读学校" :maxlength="20" placeholder="请输入学校名称"/>
          
        <van-field input-align="right" clickable name="mail" v-model="formData.email" label="邮箱账号"
          placeholder="请输入邮箱便于接受通知" error-message-align="right" />

        <van-field input-align="right" clickable name="wx" v-model="formData.wx"
          label="微信号" :maxlength="20" placeholder="请输入微信号"/>

        <van-field input-align="right" clickable name="phone" required v-model="formData.tel" label="手机号码"
          placeholder="请输入手机便于接受通知" error-message-align="right" maxlength="11"
          :style="{ marginBottom: '20px' }" />

        <van-field input-align="right" clickable name="photo_desc" required v-model="formData.content" autosize
          rows="4" type="textarea" maxlength="300" label="投稿栏目" placeholder="请输入投稿栏目" show-word-limit
          error-message-align="right"  />
          
        <van-field required input-align="right" label-class="affixs-label" label="投稿文件" error-message-align="right">
          <template #label>
            <span class="custom-title">投稿文件附件</span>
            <span class="custom-tit">(仅限zip格式,且不超过50M) </span>
          </template>
        </van-field>
        <div class="file-upload">
          <van-uploader v-model="photo_affix_list" :max-count="1" :before-read="affixBeforeRead" accept="">
            <template #preview-cover>
              <div class="preview-cover van-ellipsis">
                {{ photo_affix_list[0].name }}
              </div>
            </template>
          </van-uploader>
        </div>
      </div>
      <div class="tips">
        <div class="tip">
          <van-checkbox v-model="promise" icon-size="16px" />
          <p>我已阅读并同意《<span @click="getPageContent(5)">作品原创承诺书</span>》</p>
        </div>
        <div class="tip">
          <van-checkbox v-model="mandate" icon-size="16px" />
          <p>我已阅读并同意《<span @click="getPageContent(6)">作品授权书</span>》</p>
        </div>
      </div>
      <div class="submit">
        <van-button size="large" @click="submitFn" color="linear-gradient(to right, #5DD682, #5AFF8E)"
          :disabled="btndis">提交</van-button>
      </div>
      <!-- <div class="submit" >
        <van-button size="large" @click="editFn" color="linear-gradient(to right, #5DD682, #5AFF8E)">修改</van-button>
      </div> -->
    </div>
    <van-popup v-model="applySuccess" position="right" :style="{ height: '100%', width: '100%' }">
      <div class="apply-success">
        <div class="tip-info">
          <img src="../../assets/images/home/apply-success.png" alt="" />
          <p>恭喜您，投稿成功！</p>
        </div>
        <div class="overallCenter know" @click="getknow">我知道了</div>
      </div>
    </van-popup>
    <van-popup v-model="consentPage" position="right" :style="{ height: '100%', width: '100%' }">
      <m-loading :loading="!pageContent"> </m-loading>
      <div class="consent-page">
        <h2>{{ pageTitle }}</h2>
        <div class="container" v-html="pageContent"></div>
        <div class="consent-btn">
          <van-button size="large" color="linear-gradient(to right, #5DD682, #5AFF8E)"
            @click="confirmRead">我已认真阅读</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import SignTitle from "@/components/pub/SignTitle.vue";
import { areaList } from "@vant/area-data";

import {
  getcontribute,
  getcontributeShow,
  getpreSignedUrl,
} from "@/utils/api/activityContribute";

import { getArticleDetails, getAllUserBaby } from "@/utils/api/user";
export default {
  components: {
    "sign-title": SignTitle
  },
  data() {
    return {
      activityShow:true,
      activityContribute:{
        // 角色
        role: 0,
        // 活动简介
        intro: ``,
        unitShow: false,
        // 活动名称
        name: "",
        // 互动海报
        poster: null,
        // 活动状态
        type: 0
      },
      
      // 显示选择参赛选手
      playerShow: false,
      // 选手名称
      player: null,
      // 选手列表
      playerColumns: [],
      // 作品源文件
      photo_affix_list: [],
      // 同意承诺书
      promise: false,
      // 同意授权书
      mandate: false,
      areaName:'',
      activitySolicitId: "",
      // 提交数据
      formData: {
        content:'',
        babyId: '',
        birthday: '',
        provinceId:'',
        cityId: '',
        districtId: '',
        email: '',
        name: '',
        school: '',
        tel:'',
        uri: '',
        wx: '',
      },

      // 是否报名成功
      applySuccess: false,
      // 承诺书 授权书
      consentPage: false,
      pageTitle: "",
      // 页面内容
      pageContent: "",
      btndis: false,

      showArea:false,
      areaList,
    };
  },
  mounted() {
    this.role = this.$store.state.role;
    const infos = JSON.parse(window.localStorage.getItem("activity_Contribute_data"));
    this.activitySolicitId = infos.id;
    this.activityContribute.intro = infos.synopsis;
    this.activityContribute.name = infos.name;
    this.activityContribute.poster = infos.posterUrl;
    this.activityContribute.type = infos.status;
    this.getPageSelectInfo()
  },
  methods: {
    toApplyPage() {
      this.activityShow = false;
    },
    // 获取页面信息
    getPageSelectInfo() {
      getAllUserBaby().then((res) => {
        if (res.success) {
          this.playerColumns = res.data.map((e) => {
            return {
              birthday:e.birthday,
              text: e.name,
              value: e.id,
              list: e.babyInstitutionMd
            };
          });
        }
      });
    },
    // 地址确认
    onConfirm(values) {
      this.formData.provinceId = values[0].code
      this.formData.cityId = values[1].code
      this.formData.districtId = values[2].code
      this.areaName = values[0].name+'/'+values[1].name+'/'+values[2].name
      this.showArea = false;
    },
    // 参赛选手确定
    playerConfirm(item) {
      this.player = item.text;
      this.formData.playerVal = item.value;
      this.formData.birthday = item.birthday;
      this.playerShow = false;
    },
    // 源文件上传
    affixBeforeRead(file) {
      const fileName = file.name;
      let type = fileName.slice(-(fileName.length - fileName.lastIndexOf(".") - 1));
      if(type !=='zip'){
        this.$root.$toast.fail("请上传zip 格式的文件")
        return false;
      }
      this.photo_affix_list = [
        {
          url: "",
          status: "uploading",
          message: "上传中...",
          name: fileName
        }
      ];
      let left = this;
      let fileName2 =  + new Date() +'_'+ fileName
      let formDatamoreup = new File([file],fileName2);
      getpreSignedUrl({ "fileName": fileName2}).then(res=>{
         let url = res.data;
         if(res.code == "20000"){
             fetch(url, {
                method: 'put',
                headers: { 
                  'Content-Type': 'application/zip' 
                },
                body: formDatamoreup,
            }).then((ress) => {
             if(ress.status == "200"){
                this.photo_affix_list = [ { url: url, name: fileName, status: "done"} ];
              }else{
                this.photo_affix_list = [ { url: "", message: "上传失败，请重新上传", status: "failed"} ];
              }
            }).catch((e) => {
              this.photo_affix_list = [ { url: "", message: "上传失败，请重新上传", status: "failed"} ];
            });
         }
      }).catch(function (error) {
        left.photo_affix_list = [ { url: "", message: "上传失败，请重新上传", status: "failed"} ];
      });
    },
    // 获取承诺书授权书
    getPageContent(type) {
      if (type == 5) this.pageTitle = "作品原创承诺书";
      else this.pageTitle = "作品授权书";
      this.consentPage = true;
      this.pageContent = "";
      getArticleDetails(type).then((res) => {
        if (res.success) {
          this.pageContent = res.data;
        }
      });
    },
    confirmRead() {
      this.consentPage = false;
    },
    // 提交投稿信息
    async submitFn() {
      if (!this.promise) {
        this.$root.$toast.fail("请先阅读并同意 《作品原创承诺书》");
        return;
      }
      if (!this.mandate) {
        this.$root.$toast.fail("请先阅读并同意 《作品授权书》");
        return;
      }
      if (this.photo_affix_list.length > 0 && this.photo_affix_list[0].status === "uploading") {
        this.$root.$toast.fail("文件正在上传，请稍后再试。");
        return;
      }
      if(!this.formData.districtId){
        return this.$root.$toast.fail("请选择地址");
      }
      if(!this.formData.playerVal){
        return this.$root.$toast.fail("请选择学生");
      }
      if(!this.formData.school){
        return this.$root.$toast.fail("请输入就读学校");
      }
      if(!this.formData.tel){
        return this.$root.$toast.fail("请输入手机号");
      }
      if(!this.formData.tel){
        return this.$root.$toast.fail("请输入手机号");
      } 
      this.btndis = true;
      const p = {
        activitySolicitId:this.activitySolicitId,
        babyId: this.formData.playerVal,
        birthday: this.formData.birthday,
        provinceId:this.formData.provinceId,
        cityId: this.formData.cityId,
        districtId: this.formData.districtId,
        email: this.formData.email,
        name: this.player,
        content: this.formData.content,
        school: this.formData.school,
        tel: this.formData.tel,
        uri: this.photo_affix_list[0].url,
        wx: this.formData.wx,
      };
      getcontribute(p).then((res) => {
        if (res.success) {
          // 报名成功
          this.applySuccess = true;
          setTimeout(() => {
            this.btndis = false;
          }, 2000);
        } else {
          setTimeout(() => {
            this.btndis = false;
          }, 2000);
        }
      });
    },
    // 修改信息
    async editFn() {
      if (!this.promise) {
        this.$root.$toast.fail("请先阅读并同意 《作品原创承诺书》");
        return;
      }
      if (!this.mandate) {
        this.$root.$toast.fail("请先阅读并同意 《作品授权书》");
        return;
      }
      if (this.photo_affix_list.length > 0 && this.photo_affix_list[0].status === "uploading") {
        this.$root.$toast.fail("图片或文件正在上传，请稍后再试。");
        return;
      }
    },
    getknow() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.act-apl {
  height: 100%;
  width: 100%;
  max-width: 10rem;
  // padding: 0 20px;
  background-color: #f9f9f9;
  .form-ipt {
    padding-bottom: 60px;

    .input {
      .van-cell {
        &::after {
          border: none;
        }
      }
      .van-cell__title {
        text-align: left;
      }
      .file-upload {
        padding: 0 10px;
        background-color: #fff;
      }
    }
    .tips {
      padding-left: 100px;
      margin-top: 20px;
      .tip {
        display: flex;
        line-height: 22px;

        p {
          margin-left: 10px;
          font-size: 12px;
          color: #999;

          span {
            color: rgba(64, 158, 255, 0.7);
          }
        }
      }
    }
  }

  .apply-success {
    height: 100%;
    background-color: #fff;

    .tip-info {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img {
        margin-top: 55px;
      }
      .van-icon {
        font-size: 52px;
      }
      p {
        font-size: 18px;
        font-weight: 700;
        color: #666;
        margin-top: 14px;
        margin-bottom: 12px;
        padding: 0 40px;
        text-align: center;
      }
    }
  }

  .consent-page {
    color: #333333;
    padding-bottom: 110px;

    h2 {
      text-align: center;
    }

    .container {
      padding: 0 20px;

      p {
        line-height: 32px;
        font-size: 14px;
        min-height: 32px;
      }
    }
    .consent-btn {
      position: fixed;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      margin: 50px auto 30px auto;

      .van-button {
        border-radius: 16px;
        width: 254px;
        height: 32px;
      }
    }
  }

  .know {
    width: 209px;
    height: 40px;
    margin: 0 auto;
    margin-top: 30px;
    background: #83E38F;
    border-radius: 20px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #FFFFFF;
  }
}

.activity {
  padding-bottom: 100px;

  .banner {
    width: 100%;
    max-width: 10rem;
    position: relative;
    overflow: hidden;
    padding-bottom: 10px;

    .banner-img {
      width: 100%;
      height: 160px;
      position: absolute;
      z-index: 0;
      top: 0;
      left: 0;
    }

    .banner-content {
      position: relative;
      margin: 0 auto;
      width: 100%;
      margin-top: 103px;
      z-index: 5;
      padding: 0 12px;
      min-height: 10px;
      width: 335px;
      background-color: #fff;
      border-radius: 8px;
      overflow: hidden;
      padding-bottom: 10px;
      box-shadow: 0px 2px 5px rgba(5, 75, 27, 0.2);

      h2 {
        min-height: 28px;
        line-height: 28px;
        color: #000;
        margin: 0;
        margin-top: 12px;
        font-weight: 900;
        font-size: 20px;
      }

      .act-infos {
        margin-top: 4px;

        .status {
          font-size: 12px;
          line-height: 16px;
          height: 16px;
          background-color: #6cdd8f;
          color: #fff;
          text-align: center;
          border-radius: 0 8px 0 8px;
          width: 46px;

          &.end {
            background-color: #eee;
          }

          &.red {
            background-color: red;
          }
        }
      }
    }
  }

  .act-attention {
    background-color: #fff;
    padding: 0 20px;
    text-align: left;
    margin-bottom: 80px;

    .act-intro {
      line-height: 22px;
      font-size: 14px;
      color: #999;
    }
  }

  .unit-lst-wrap {
    height: 100%;
    overflow-y: scroll;
    margin: 60px 0;
    padding: 0 36px;
  }

  .unit-lst {
    line-height: 22px;
    font-size: 14px;
    color: #999;
    text-align: left;
    padding-bottom: 100px;
  }

  .contribute {
    text-align: center;
    color: #16d77a;
    background-color: unset;
    position: fixed;
    bottom: 50px;
    display: flex;
    width: 100%;
    justify-content: center;

    .van-button {
      border-radius: 16px;
      width: 254px;
      height: 32px;
      box-shadow: 0 10px 10px #0002;
    }
  }
}
</style>
<style lang="scss">
@import "../../assets/css/customer.scss";
.act-apl {
  text-align: left;
  .affixs-label {
    width: unset;
    &+.van-field__value {
      display: none;
    }
  }
  .input {
    .van-uploader {
      @include from-upload-style;
    }
  }
  .preview-cover {
    position: absolute;
    bottom: 0;
    box-sizing: border-box;
    width: 100%;
    padding: 4px;
    color: #fff;
    font-size: 12px;
    text-align: center;
    background: rgba(0, 0, 0, 0.3);
  }
  .submit {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    .van-button {
      border-radius: 16px;
      width: 254px;
      height: 32px;
    }
  }
  .custom-tit {
    font-size: 12px;
    color: #cccccc;
  }
}
.activity {
  .van-popup {
    border-radius: 20px 20px 0 0;
    overflow-y: hidden;

    .van-icon {
      right: calc((100% - 16px) / 2);
      font-size: 16px;

      &::after {
        content: "";
        position: absolute;
        left: -3px;
        top: -3px;
        height: 20px;
        width: 20px;
        box-sizing: content-box;
        border: 1px solid #c8c9cc;
        border-radius: 50%;
      }
    }
  }
}
</style>
